<template>
  <VModal :show="show" title="گزارش" :large="true">
    <div class="grid grid-cols-3 justify-items-center p-2">
      <div>
        <Input type="text" placeholder="شماره فاکتور" class="py-1 w-auto" v-model="filter.factorNumber"/>
        <Input type="text" placeholder="شماره میز" class="mt-2 py-1 w-auto" v-model="filter.tableNumber"/>
        <Input type="text" placeholder="نام مشتری" class="mt-2 py-1 w-auto" v-model="filter.customerName"/>
      </div>

      <div class="flex flex-col text-white">
        <div>
          <input type="radio" name="state" id="state1" value="1" v-model="filter.state">
          <label class="mr-2" for="state1">همه موارد</label>
        </div>
        <div class="mt-2">
          <input type="radio" name="state" id="state2" value="2" v-model="filter.state">
          <label class="mr-2" for="state2">آماده تحویل</label>
        </div>
        <div class="mt-2">
          <input type="radio" name="state" id="state3" value="3" v-model="filter.state">
          <label class="mr-2" for="state3">تحویل شده</label>
        </div>
      </div>


      <div class="flex flex-col text-white">
        <div>
          <input type="radio" name="state" id="shift1" value="1" v-model="filter.shift">
          <label class="mr-2" for="shift1">روز و شب</label>
        </div>
        <div class="mt-2">
          <input type="radio" name="shift" id="shift2" value="2" v-model="filter.shift">
          <label class="mr-2" for="shift2">روز</label>
        </div>
        <div class="mt-2">
          <input type="radio" name="shift" id="shift3" value="3" v-model="filter.shift">
          <label class="mr-2" for="shift3">شب</label>
        </div>
      </div>
    </div>
    <hr class="my-4">
    <table class="w-full text-white divide-y">
      <thead class="text-xs">
      <tr>
        <td>شماره فاکتور</td>
        <td>شماره میز</td>
        <td>نام مشتری</td>
        <td>سفارش گیرنده</td>
        <td>ساعت ارسال به آشپزخانه</td>
        <td>تحویل گیرنده</td>
        <td>ساعت تحویل</td>
        <td>کاربر تایید تحویل</td>
        <td>ساعت تایید تحویل</td>
        <td>آخرین وضعیت</td>
        <td>جزئیات</td>
      </tr>
      </thead>
      <tbody class="divide-y text-sm">
      <tr
          v-for="report in reports"
          :key="report">
        <td class="py-2">{{ report.FactorNumber }}</td>
        <td>{{ report.TableNo }}</td>
        <td>{{ report.CustomerName }}</td>
        <td>{{ report.create_USER }}</td>
        <td>{{ report.CreateTime }}</td>
        <td>{{ report.delivery_User }}</td>
        <td>{{ report.deliveryTime }}</td>
        <td>{{ report.verify_Delivery_User }}</td>
        <td>{{ report.verify_Delivery_Time }}</td>
        <td>{{ report.lastStatus }}</td>
        <td>
          <EyeIcon class="w-5 mx-auto cursor-pointer" @click="getFactorDetail(report.FactorNumber)"/>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- Detail Modal -->
    <VModal
        :show="detailModal"
        title="جزئیات فاکتور"
        @click="detailModal = false">
      <table class="w-full text-white">
        <thead>
        <tr>
          <td>کد</td>
          <td>نام</td>
          <td>تعداد</td>
          <td>بیرون بر</td>
        </tr>
        </thead>
        <tbody class="divide-y text-sm">
        <tr
            v-for="detail in details"
            :key="detail.KalaCode">
          <td class="py-2">{{ detail.KalaCode }}</td>
          <td>{{ detail.KalaName }}</td>
          <td>{{ detail.Qty }}</td>
          <td>{{ detail.TakewayQty }}</td>
        </tr>
        </tbody>
      </table>
    </VModal>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import {getMonitorReports} from "@/API/API";
import Input from "../Input";
import {EyeIcon} from "@heroicons/vue/outline";

export default {
  name: "ReportModal",
  props: ['show', 'monitorId'],
  components: {Input, VModal, EyeIcon},
  data() {
    return {
      filter: {
        factorNumber: '',
        tableNumber: '',
        customerName: '',
        state: '',
        shift: '',
      },
      reports: {},
      detailModal: false,
      details: {}
    }
  },
  created() {
    this.getReports()
  },
  methods: {
    async getReports() {
      this.reports =
          (await getMonitorReports(
                  1,
                  this.monitorId,
                  this.filter.factorNumber,
                  this.filter.customerName,
                  this.filter.tableNumber,
                  this.filter.state,
                  this.filter.shift)
          ).data.result
    },
    async getFactorDetail(factorNumber) {
      this.detailModal = true
      this.details = (await getMonitorReports(2, this.monitorId, factorNumber)).data.result
    }
  },
  watch: {
    'monitorId'() {
      this.getReports()
    },
    filter: {
      deep: true,
      handler() {
        this.getReports()
      }
    }
  }
}
</script>

<style scoped>

</style>